import { OtpAuthorizeStep } from "../../shared/OtpAuthorizeStep";
import { PinAuthorizeStep } from "../../shared/PinAuthorizeStep";

export function Step3Authorize({ confirmationMode, ...props }) {
  if (confirmationMode === "PIN") {
    return (
      <PinAuthorizeStep
        control={props.pinControl}
        handleSubmit={props.handlePinSubmit}
        pinValue={props.pinValue}
        onSubmit={props.onSubmit}
        isAuthorizing={props.isAuthorizing}
        submitLabel={props.submitLabel}
      />
    );
  }

  return (
    <OtpAuthorizeStep
      control={props.control}
      handleSubmit={props.handleSubmit}
      otpValue={props.otpValue}
      otpRecipient={props.otpRecipient}
      onSubmit={props.onSubmit}
      isAuthorizing={props.isAuthorizing}
      onResend={props.onResend}
      resendSecondsLeft={props.resendSecondsLeft}
      isResendCooldownActive={props.isResendCooldownActive}
      submitLabel={props.submitLabel}
    />
  );
}
